export default __webpack_public_path__ + "static/media/Mastercard.ec4411c5.svg";